<template>
  <div class="group-setup">
    <v-progress-linear indeterminate color="orange" v-if="loading"></v-progress-linear>
    <v-layout row v-if="errors">
      <v-flex>
        <Alert @dismissed="onDismissed" :text="errors"></Alert>
      </v-flex>
    </v-layout>
    <v-card>
      <v-card-title dark>
        <h3 class="ma-2  orange--text">Project Member Participants</h3>
      </v-card-title>
      <v-divider color="orange"></v-divider>
      <v-form>
        <v-row>
          <v-col cols="12">
            <ParticipantsList :participants="participants" @deleteParticipant="deleteParticipant($event)">
            </ParticipantsList>
          </v-col>
        </v-row>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import Alert from "@/components/shared/Alert";
import ParticipantsList from "../child/ParticipantsList";
import { ProjectService } from "../../../../services/project-service.js";
import { checkError } from "@/config/errors.js";

export default {
  name: "groupSetUpFrom",
  props: ["uuid"],
  components: { Alert, ParticipantsList },

  data: () => ({
    cpRole: false,
    loading: false,
    errors: null,
    snackbar: false,
    succesMsg: "",
    participants: [],
  }),

  mounted() {
    this.getParticipantList();
  },

  methods: {
    getParticipantList() {
      if (this.uuid !== null) {
        ProjectService.getParticipantList(this.uuid)
          .then((response) => {
            this.loading = false;
            if (response.data.data) {
              this.participants = response.data.data;
            }
          })
          .catch((error) => {
            this.loading = false;
            this.participants = [];
            let data = error.response.data;
            let errorOutput = checkError.errorFormatting(data);
            this.errors = errorOutput;
          });
      }
    },
  },
};
</script>
